import BrkfstTable from './BrkfstTable';

export default BrkfstTable;
